import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getCustomersData, getSection, renderTable } from './saleReportHelpers';
import CustomerLink from '../../../Components/CustomerLink';

// ลูกค้า/Delivery — combines the delivery-checker inline table (รายการลูกค้าที่ไม่รายงาน,
// includes the per-row delivery-level edit) with the customer list (ลูกค้า (Customers)).
const CustomerDeliveryTab = ({
    fullReport,
    deliveryCheckerData,
    loadingDelivery,
    errorDelivery,
    startDate,
    fetchDeliveryChecker,
    editRow,
    setEditRow,
    tempLevel,
    setTempLevel,
    handleUpdateDeliveryLevel,
    showCustomers,
    setShowCustomers,
}) => {
    return (
        <>
            <div className="btc-section" style={{ gridColumn: 'span 2' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h3>รายการลูกค้าที่ไม่รายงาน {fullReport?.masterReport?.sellerName ? ` ${fullReport.masterReport.sellerName}` : ''} - {deliveryCheckerData.length} ราย</h3>
                    <button
                        className="btc-btn btn-sm"
                        style={{ backgroundColor: "#17a2b8" }}
                        onClick={() => {
                            const master = getSection(fullReport, ['master', 'masterReport', 'report', 'masterData'], null);
                            if (master) fetchDeliveryChecker(master.sellerId, startDate);
                        }}
                        disabled={loadingDelivery}
                    >
                        {loadingDelivery ? 'กำลังตรวจสอบ...' : 'เริ่มการตรวจสอบ (Run Check)'}
                    </button>
                </div>

                {loadingDelivery && <p>กำลังตรวจสอบข้อมูลการส่ง...</p>}
                {errorDelivery && <p className="error">{errorDelivery}</p>}

                {!loadingDelivery && !errorDelivery && (
                   renderTable(
                       '',
                       deliveryCheckerData,
                       [
                           {
                               key: 'customerName',
                               label: 'ชื่อลูกค้า',
                               format: (v, it) => {
                                   const level = Number(it.deliveryLevel);
                                   let style = { fontWeight: 'normal' };
                                   if (level === 3) {
                                       style = { color: 'red', fontWeight: 'bold' };
                                   } else if (level === 1) {
                                       style = { color: 'gray' };
                                   }
                                   return <span style={style}><CustomerLink name={v} code={it.customerId} /></span>;
                               }
                           },
                           {
                               key: 'deliveryLevel',
                               label: 'ระดับ',
                               format: (v, it) => (
                                   editRow === it.customerId ? (
                                       <input
                                           type="number"
                                           value={tempLevel}
                                           autoFocus
                                           style={{
                                               width: '60px',
                                               padding: '4px',
                                               borderRadius: '4px',
                                               border: '1px solid #007bff',
                                               textAlign: 'center'
                                           }}
                                           onChange={(e) => setTempLevel(e.target.value)}
                                       />
                                   ) : (() => {
                                       const level = Number(v);
                                       let style = { fontWeight: 'normal' };
                                       if (level === 3) {
                                           style = { color: 'red', fontWeight: 'bold' };
                                       }  else if (level === 1) {
                                           style = { color: 'gray' };
                                       }
                                       return <span style={style}>{v}</span>;
                                   })()
                               )
                           },
                           { key: 'status', label: 'สถานะ', format: (v, it) => {
                               const level = Number(it.deliveryLevel);
                               let style = { fontWeight: 'bold' };
                               if (level === 3) {
                                   style.color = 'red';
                               } else if (level === 2) {
                                   style.color = '#ffc107';
                               } else if (level === 1) {
                                   style.color = 'gray';
                               } else {
                                   style.color = v === 'BUY' ? 'green' : (v === 'NO_DATA' ? 'orange' : 'red');
                               }
                               return (
                                   <span style={style}>
                                       {v}
                                   </span>
                               );
                           }},
                           {
                               key: 'actions',
                               label: 'จัดการ',
                               format: (_, it) => {
                                   const master = getSection(fullReport, ['master', 'masterReport', 'report', 'masterData'], null);
                                   const isEditing = editRow === it.customerId;
                                   return (
                                       <div style={{ display: 'flex', gap: '5px' }}>
                                           {!isEditing ? (
                                               <button
                                                   className="btc-btn btn-sm"
                                                   style={{
                                                       backgroundColor: "#007bff",
                                                       borderRadius: '4px',
                                                       padding: '5px 10px',
                                                       display: 'inline-flex',
                                                       alignItems: 'center',
                                                       justifyContent: 'center'
                                                   }}
                                                   title="Edit Delivery Level"
                                                   onClick={() => {
                                                       setEditRow(it.customerId);
                                                       setTempLevel(it.deliveryLevel);
                                                   }}
                                               >
                                                   <FontAwesomeIcon icon={faEdit} />
                                               </button>
                                           ) : (
                                               <>
                                                   <button
                                                       className="btc-btn btn-sm"
                                                       style={{
                                                           backgroundColor: "#46af38",
                                                           borderRadius: '4px',
                                                           padding: '5px 10px',
                                                           display: 'inline-flex',
                                                           alignItems: 'center',
                                                           justifyContent: 'center'
                                                       }}
                                                       title="Save"
                                                       onClick={() => {
                                                           handleUpdateDeliveryLevel(it.customerId, master?.sellerId, tempLevel);
                                                           setEditRow(null);
                                                       }}
                                                   >
                                                       <FontAwesomeIcon icon={faSave} />
                                                   </button>
                                                   <button
                                                       className="btc-btn btn-sm"
                                                       style={{
                                                           backgroundColor: "#dc3545",
                                                           borderRadius: '4px',
                                                           padding: '5px 10px',
                                                           display: 'inline-flex',
                                                           alignItems: 'center',
                                                           justifyContent: 'center'
                                                       }}
                                                       title="Cancel"
                                                       onClick={() => setEditRow(null)}
                                                   >
                                                       <FontAwesomeIcon icon={faTimes} />
                                                   </button>
                                               </>
                                           )}
                                       </div>
                                   );
                               }
                           }
                       ],
                       'ไม่พบข้อมูลการตรวจสอบ'
                   )
                )}
            </div>

            {(() => {
                const { list, count } = getCustomersData(fullReport);
                return (
                    <div className="btc-section">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <h3 style={{ margin: 0 }}>ลูกค้า (Customers) {fullReport?.masterReport?.sellerName ? ` ${fullReport.masterReport.sellerName}` : ''} - {count} ราย</h3>
                            <button onClick={() => setShowCustomers((v) => !v)}>
                                {showCustomers ? 'ซ่อนลูกค้า' : 'แสดงลูกค้า'}
                            </button>
                        </div>
                        {showCustomers && (
                            <div style={{ marginTop: '8px' }}>
                                {renderTable(
                                    '',
                                    list,
                                    [
                                        { key: 'customerName', label: 'ชื่อร้าน', format: (v, it) => <CustomerLink name={v} code={it.customerId} /> },
                                        { key: 'orders', label: 'รายการ', format: (v) => (Array.isArray(v) ? v.length : (v ?? '')) },
                                    ]
                                )}
                            </div>
                        )}
                    </div>
                );
            })()}
        </>
    );
};

export default CustomerDeliveryTab;
